import React, { useContext, createContext, useState } from "react";
import { useRecoilState } from "recoil";
import Header from "./header";
import { useLocale } from "react-aria";

import "../styles/index.scss";
import Footer from "./footer";
import { langState, firstLoadState } from "./recoilAtom";
import CookieBanner from "./cookies/cookies";

interface layoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<layoutProps> = ({ children }) => {
  const [lang, setLang] = useRecoilState(langState);
  const { locale } = useLocale();
  const [firstLoad, setFirstLoad] = useRecoilState(firstLoadState);

  React.useEffect(() => {
    firstLoad && setLang(locale);
    setFirstLoad(false);
  }, []);

  return (
    <main lang={lang} className="layout-wrapper">
      <Header className="layout-wrapper" />
      {children}
      <CookieBanner />
      <Footer />
    </main>
  );
};

export const ContentWrapper: React.FC<any> = ({ className, children }) => (
  <div className={`layout-content ${className}`}>{children}</div>
);

export default Layout;
